import * as CONST from "./actionTypes";

const INIT_STATE = {
  error: "",
  loading: false,
  total: 0,
  totalCount : 0,
  listing: [],
  assetListing:[],
  assetTotal:0
};

const Wallet = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CONST.POST_ASSET_WITHDRAW:
      return {
        ...state,
        loading: true,
      };

    case CONST.ASSET_WITHDRAW_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };

    case CONST.ASSET_WITHDRAW_FAILED:
      return {
        ...state,
        loading: false,
        error: "",
      };

      case CONST.GET_WITHDRAW_HISTORY:
        return {
          ...state,
          loading: true,
        }
  
      case CONST.WITHDRAW_HISTORY_SUCCESS:
        return {
          ...state,
          assetListing: action.payload.data || [],
          assetTotal: action.payload.total || 0,
          loading: false,
          error: "",
        }
  
      case CONST.WITHDRAW_HISTORY_FAILED:
        return {
          ...state,
          error: action.payload,
          loading: false,
        }
        case CONST.TRANSACTION_HISTORY:
          return {
            ...state,
            loading: true,
          }
    
        case CONST.TRANSACTION_HISTORY_SUCCESS:
          return {
            ...state,
            listing: action.payload.data || [],
            total: action.payload.total || 0,
            loading: false,
            error: "",
          }
    
        case CONST.TRANSACTION_HISTORY_FAILED:
          return {
            ...state,
            error: action.payload,
            loading: false,
          }
    
    
    default:
      return state;
  }
};

export default Wallet;
